module.exports = __webpack_public_path__ + "assets/img/warrior-name-e4f2e72a.png";